import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';
import { styled } from '@compiled/react';

import Heading from '@atlaskit/heading';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import NotFound from './images/NotFound.png';

const i18n = defineMessages({
	title: {
		id: 'space-directory.not.found.title',
		// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "We couldn't find any spaces",
		description: 'Message letting user know search or filtering did not return results',
	},
	subtext: {
		id: 'space-directory.not.found.subtext',
		defaultMessage: 'No spaces matched your filters. Try again with fewer filters.',
		description: 'Additional message letting user know search or filtering did not return results',
	},
	altText: {
		id: 'space-directory.not.found.alt.text',
		defaultMessage: 'Broken magnifying glass',
		description: 'Image alt text for broken magnifying Glass',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NotFoundContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	flexShrink: 1,
	alignItems: 'center',
	justifyContent: 'center',
	marginTop: token('space.300'),
});

export const EmptyState: FC = () => {
	const intl = useIntl();
	return (
		<NotFoundContainer>
			<img alt={intl.formatMessage(i18n.altText)} src={NotFound} width="134px" />
			<Heading size="xlarge">
				<FormattedMessage {...i18n.title} />
			</Heading>
			<Text as="p">
				<FormattedMessage {...i18n.subtext} />
			</Text>
		</NotFoundContainer>
	);
};
